export default __webpack_public_path__ + "static/media/Dhidhie_Sapari.1854935a.png";